import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
// import RadialChart1 from "./userpanelChart1";
// import RadialChart2 from "./userpanelChart2";
import RadialChart3 from "./userpanelChart3";
const UserPanel = () => {
  const [totalContracts, setTotalContracts] = useState(0);
  const [totalExpired, setTotalExpired] = useState(0);
  const [totalActive, setTotalActive] = useState(0);
  const [totalAddendums, setTotalAddendums] = useState(0);
  const [per, setPer] = useState(0);
  useEffect(() => {
    // Simulate fetching contract IDs from an API
    const fetchContracts = async () => {
      try {
        // Replace with your actual API endpoint
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/contracts`,{
          method: 'GET',
          headers: {
            "Authorization": `Bearer ${sessionStorage.getItem('authToken')}`
          }
        });
        const data = await response.json();
        setTotalContracts(data);
      } catch (error) {
        console.error("Error fetching contracts:", error);
      }
    };
    const fetchAddendums = async () => {
      try {
        // Replace with your actual API endpoint
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/addendums`,{
          method: 'GET',
          headers: {
            "Authorization": `Bearer ${sessionStorage.getItem('authToken')}`
          }
        });
        const data = await response.json();
        setTotalAddendums(data.length);
      } catch (error) {
        console.error("Error fetching addendums:", error);
      }
    };
    fetchContracts();
    fetchAddendums();
  }, []);
  useEffect(()=>{
    if(typeof(totalContracts) === "object"){
      const expiredConts = totalContracts.filter(cont => cont.status==="expired");
      setTotalExpired(expiredConts.length);
      const activeConts = totalContracts.filter(cont => cont.status === "active");
      setTotalActive(activeConts.length);
      setPer(Math.ceil(Number(activeConts.length/totalContracts.length)*100));
    }
  }, [totalContracts])
  return (
    <React.Fragment>
      <Row>
        <Col xl={3} sm={6}>
          <Card>
            <CardBody>
              <div className="d-flex text-muted">
                <div className="flex-grow-1 overflow-hidden">
                  <p className="mb-1">All Contracts</p>
                  <h5 className="mb-3">{totalContracts.length}</h5>
                  <p className="text-truncate mb-0">
                    <span className="text-success me-2">
                      {/* {" "}
                      0.02%{" "}
                      <i className="ri-arrow-right-up-line align-bottom ms-1"></i> */}
                    </span>{" "}
                    Updated 10 secs ago
                  </p>
                </div>
                <div className="flex-shrink-0 me-3 align-self-center">
                  {/* <div id="radialchart-1" className="apex-charts" dir="ltr">
                    <RadialChart1 />
                  </div> */}
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col xl={3} sm={6}>
          <Card>
            <CardBody>
              <div className="d-flex text-muted">
                <div className="flex-grow-1 overflow-hidden">
                  <p className="mb-1">Total Addendums</p>
                  <h5 className="mb-3">{totalAddendums}</h5>
                  <p className="text-truncate mb-0">
                    <span className="text-success me-2">
                      {/* {" "}
                      1.7%{" "}
                      <i className="ri-arrow-right-up-line align-bottom ms-1"></i> */}
                    </span>{" "}
                    Updated 10 secs ago
                  </p>
                </div>
                <div className="flex-shrink-0 me-3 align-self-center">
                  {/* <RadialChart2
                    id="radialchart-2"
                    className="apex-charts"
                    dir="ltr"
                  /> */}
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col xl={3} sm={6}>
          <Card>
            <CardBody>
              <div className="d-flex text-muted">
                <div className="flex-grow-1 overflow-hidden">
                  <p className="mb-1">Active Contracts</p>
                  <h5 className="mb-3">{totalActive}</h5>
                  <p className="text-truncate mb-0">
                    <span className="text-danger me-2">
                      {/* {" "}
                      0.01%{" "}
                      <i className="ri-arrow-right-down-line align-bottom ms-1"></i> */}
                    </span>{" "}
                    From previous
                  </p>
                </div>
                
                <div className="flex-shrink-0 me-3 align-self-center">
                  <RadialChart3
                    id="radialchart-3"
                    className="apex-charts"
                    dir="ltr"
                    num={per}
                  />
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col xl={3} sm={6}>
          <Card>
            <CardBody>
              <div className="d-flex text-muted">
                <div className="flex-grow-1 overflow-hidden">
                  <p className="mb-1">Expired Contracts</p>
                  <h5 className="mb-3">{totalExpired}</h5>
                  <p className="text-truncate mb-0">
                    <span className="text-success me-2">
                      {" "}
                      0.01%{" "}
                      <i className="ri-arrow-right-up-line align-bottom ms-1"></i>
                    </span>{" "}
                    From previous
                  </p>
                </div>
                
                <div className="flex-shrink-0 me-3 align-self-center">
                  <div className="avatar-sm">
                    <div className="avatar-title bg-light rounded-circle text-primary font-size-20">
                      <i className="ri-delete-bin-line"></i>
                    </div>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};
export default UserPanel;
 